import { AddressFormattingSettings } from '@models/businessSettings/settings';
import {
	BusinessMatterClientWithAssociations,
	MatterFileType,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { MapAddress } from '@state/global/tags/mappings/tags.address';
import { TagAddress } from '@state/global/tags/models/address.model';

//This function is used to get the borrowers for the matter file type
export const getBorrowers = (
	matterFileType: MatterFileType,
	signors: PersonMatterClientWithAssociations[],
	otherPartiesWithAssociations: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[],
): (
	| PersonMatterClientWithAssociations
	| BusinessMatterClientWithAssociations
)[] => {
	const purchasers =
		matterFileType === MatterFileType.SALE
			? otherPartiesWithAssociations
			: signors;

	return matterFileType === MatterFileType.REFINANCE ? signors : purchasers;
};

//This function is used to get the borrower service address
export const getBorrowerServiceAddress = (
	matterFileType: MatterFileType,
	signors: PersonMatterClientWithAssociations[],
	otherPartiesWithAssociations: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[],
	addressFormattingSettings: AddressFormattingSettings,
): TagAddress => {
	const borrowers = getBorrowers(
		matterFileType,
		signors,
		otherPartiesWithAssociations,
	);
	const primaryClient =
		borrowers.find((client) => client?.primaryContact) || borrowers[0];

	return MapAddress(primaryClient?.serviceAddress, addressFormattingSettings);
};
